<template>
    <section>
        <header class="justify-between align-items-end mb-3">
            <b-form-group
                :label="$t('Service')"
                :label-for="uuid + '_service'"
                class="flex-grow-1 mb-0"
            >
                <service-select
                    :id="uuid + '_service'"
                    v-model="service"
                    :params="params"
                    :project-id="projectId"
                    required
                />
            </b-form-group>

            <b-button
                :disabled="!service"
                :title="$t('Add service')"
                class="ml-3"
                @click="newService"
            >
                <fa icon="plus" :title="$t('Add service')"/>
            </b-button>
        </header>

        <b-alert v-if="!services.length" show>
            {{ $t('No results found') }}
        </b-alert>

        <service-select-item
            v-for="(service, index) in services"
            :key="index"
            :value="services[index]"
            :api-url="apiUrl ? apiUrl + '/' + service.id : null"
            :multipliers="multipliers"
            class="mb-3"
            @input="updateItem(index, $event)"
            @deleted="removeService(index)"
        />
    </section>
</template>
<script>
    import ServiceSelectItem from '@/components/ServiceSelectItem'
    import ServiceSelect from '@/components/selects/ServiceSelect';

    import { clone } from 'lodash';


    export default {
        name: 'ServicesSelect',
        components: {ServiceSelect, ServiceSelectItem},
        props: {
            value: {
                type: Array,
                default: () => []
            },
            projectId: {
                type: [Number, String],
                required: true
            },
            apiUrl: {
                type: String,
                default: null
            },
            multipliers: {
                type: Array,
                default: () => []
            },
            params: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                services: [],
                service: null,
                pending: false,
            }
        },
        watch: {
            value: {
                handler(newValue) {
                    this.services = clone(newValue);
                },
                immediate: true
            },
        },
        methods: {
            newService() {
                if (!this.service || this.pending) {
                    return;
                }

                this.pending = true;

                try {
                    if (this.apiUrl) {
                        this.axios.post(this.apiUrl + '/' + this.service.id)
                    }

                    this.services.push(this.service);
                    this.service = null;

                    this.$emit('input', this.services);
                } finally {
                    this.pending = false;
                }
            },

            removeService(index) {
                this.services.splice(index, 1);

                this.$emit('input', this.services);
            },

            updateItem(index, data) {
                this.services[index].info = data;
                this.$emit('input', this.services);
            }
        }
    }
</script>
